import { AutoLogin } from '../../components/AutoLogin/AutoLogin';

export const Login: React.FC = () => {
  return (
    <div className="w-full min-h-screen flex items-center justify-center">
      <AutoLogin />
    </div>
  );
};
